export default __webpack_public_path__ + "static/media/sort_up.0f23ca46.svg";